import { useTranslation } from "react-i18next"

export function ResultMixedCompulsoryPage({ goToIntroPage }: { goToIntroPage: () => void }) {
    const { t } = useTranslation(["btwtool", "common"])

    return (
        <div>
            <h1>{t("result__mixedCompulsory_name")}</h1>
            <h2>{t("result__mixedCompulsory_description")}</h2>
            <p>{t("result__mixedCompulsory_slug")}</p>
            <div className="wrapper-row">
                <button className="button-primary" onClick={() => window.open(process.env.REACT_APP_GLIDE_URL)}>{t("button__finish", { ns: "common" })}</button>
                <button className="button-secondary">{t("button__info", { ns: "common" })}</button>
                <button className="button-void" onClick={goToIntroPage}>{t("button__retry", { ns: "common" })}</button>
            </div>
        </div>
    )
}